import ApiClient from '@/services/ApiClient/ApiClient'
import { AppConfig } from '@/config/config'

export default new ApiClient({ baseUrl: AppConfig.GATEWAY_CLIENT_REQUESTS_URL })
